<template>
  <div class="page-header-wrapper">
    <header class="page-header">
      <div class="logo">
        <router-link to="/">
          <img src="../../../public/images/timeonline-logo-01.svg" />
        </router-link>
      </div>
      <div v-if="title" class="title">{{ title }}</div>
    </header>
    <Navigation />
  </div>
</template>

<script>
import Navigation from './Navigation';
export default {
  name: 'PageHeader',
  components: { Navigation },
  computed: {
    title() {
      return this.$store.state.pageTitle;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../styles/colors.scss';
@import '../styles/variables.scss';

.page-header-wrapper {
  position: relative;
  .page-header {
    margin: 0 auto;
    padding: 0 7.5%;
    background: url('../../../public/images/timeonline_bkrnd.webp');
    .logo {
      padding: $title-logo-vertical-padding 0;
      img {
        max-height: 100%;
        height: auto;
        width: 290px;
      }
    }
    .title {
      display: inline-block;
      margin-bottom: $title-logo-vertical-margin;
      height: 57px;
      color: #ffffff;
      font-size: 48px;
      font-weight: 300;
      letter-spacing: -1.74px;
      line-height: 57px;
    }
  }
}
@media print {
  .page-header-wrapper {
    display: none;
  }
}
</style>
